export const GET_HISTORICAL_ALARMS = 'GET_HISTORICAL_ALARMS';
export const GET_HISTORICAL_ALARMS_FAIL = 'GET_HISTORICAL_ALARMS_FAIL';
export const GET_HISTORICAL_ALARMS_SUCCESS = 'GET_HISTORICAL_ALARMS_SUCCESS';

export const SWITCH_HIST_ALARMS_REQUEST_GET = 'SWITCH_HIST_ALARMS_REQUEST_GET';
export const SWITCH_HIST_ALARMS_RESPONSE_GET_SUCCESS = 'SWITCH_HIST_ALARMS_RESPONSE_GET_SUCCESS';
export const SWITCH_HIST_ALARMS_RESPONSE_GET_FAIL = 'SWITCH_HIST_ALARMS_RESPONSE_GET_FAIL';

export const HISTORICAL_ALARMS_DELETE_REQUEST = 'HISTORICAL_ALARMS_DELETE_REQUEST';
export const HISTORICAL_ALARMS_DELETE_SUCCESS = 'HISTORICAL_ALARMS_DELETE_SUCCESS';
export const HISTORICAL_ALARMS_DELETE_FAIL = 'HISTORICAL_ALARMS_DELETE_FAIL';